<template>
  <vx-card>
    <form-wizard
      color="rgba(var(--vs-primary), 1)"
      :title="'SALVAMENTOS'"
      :subtitle="'Formulario para crear y editar salvamentos'"
      :hide-buttons="false"
      ref="formWizard"
    >
      <tab-content title="Datos Generales" class="mb-5" :before-change="validateGeneralData">
        <form data-vv-scope="general-data">
          <vs-divider class="vx-col w-full mt-5" position="left" color="dark">Información general</vs-divider>
          <div class="vx-row">
            <div class="vx-col md:w-1/3 w-full">
              <label for="category" class="w-full select-large">Categoría</label>
              <v-select
                  id="category"
                  name="category"
                  label="name"
                  index="id"
                  :options="categories"
                  :placeholder="'Seleccione..'"
                  :searchable="true"
                  v-model="entryModel.category"
                  v-validate="'required'"
                  class="w-full"
              />
              <span class="text-danger">{{ errors.first("general-data.category") }}</span>
              <br/>
            </div>

            <div class="vx-col md:w-1/3 w-full">
              <label for="name" class="w-full select-large">Nombre</label>
              <vs-input
                  id="name" name="name" v-model="entryModel.name" v-validate="'required'" class="w-full" autocomplete="off"
              />
              <span class="text-danger">{{ errors.first("general-data.name") }}</span>
              <br/>
            </div>

            <div class="vx-col md:w-1/3 w-full">
              <label for="claim_code" class="w-full select-large">Código de Reclamo</label>
              <vs-input
                  id="claim_code" name="claim_code" v-model="entryModel.claim_code" v-validate="'required'" class="w-full"
                  autocomplete="off"
              />
              <span class="text-danger">{{ errors.first("general-data.claim_code") }}</span>
              <br/>
            </div>
          </div>

          <vs-divider class="vx-col w-full mt-5" position="left" color="dark">Información de salvamento</vs-divider>

          <div class="vx-row">
            <div class="vx-col md:w-1/2 w-full">
              <label for="price" class="w-full select-large">Precio</label>
              <vs-input
                  id="price" name="price" v-model="entryModel.price" v-validate="'required'" class="w-full" autocomplete="off"
              />
              <span class="text-danger">{{ errors.first("general-data.price") }}</span>
              <br/>
            </div>

            <div class="vx-col md:w-1/2 w-full">
              <label for="condition" class="w-full select-large">Condición de salvamento</label>
              <vs-input
                  id="condition" name="condition" v-model="entryModel.condition" v-validate="'required'" class="w-full"
                  autocomplete="off"
              />
              <span class="text-danger">{{ errors.first("general-data.condition") }}</span>
              <br/>
            </div>
          </div>

          <div class="vx-row">
            <div class="vx-col md:w-1/3 w-full">
              <label for="brand" class="w-full select-large">Marca</label>
              <vs-input
                  id="brand" name="brand" v-model="entryModel.features.brand" v-validate="'required'" class="w-full"
                  autocomplete="off"
              />
              <span class="text-danger">{{ errors.first("general-data.brand") }}</span>
              <br/>
            </div>

            <div class="vx-col md:w-1/3 w-full">
              <label for="model" class="w-full select-large">Modelo</label>
              <vs-input
                  id="model" name="model" v-model="entryModel.features.model" v-validate="'required'" class="w-full"
                  autocomplete="off"
              />
              <span class="text-danger">{{ errors.first("general-data.model") }}</span>
              <br/>
            </div>

            <div class="vx-col md:w-1/3 w-full">
              <label for="year" class="w-full select-large">Año</label>
              <vs-input
                  id="year" name="year" v-model="entryModel.features.year" v-validate="'required|digits:4'" class="w-full"
                  autocomplete="off"
              />
              <span class="text-danger">{{ errors.first("general-data.year") }}</span>
              <br/>
            </div>
          </div>

          <div class="vx-row">
            <div class="vx-col md:w-1/3 w-full">
              <label for="license_plate" class="w-full select-large">Placa</label>
              <vs-input
                  id="license_plate" name="license_plate" v-model="entryModel.features.license_plate" class="w-full"
                  v-validate="'required'" autocomplete="off"
              />
              <span class="text-danger">{{ errors.first("general-data.license_plate") }}</span>
              <br/>
            </div>

            <div class="vx-col md:w-1/3 w-full">
              <label for="chassis" class="w-full select-large">Chasis</label>
              <vs-input
                  id="chassis" name="chassis" v-model="entryModel.features.chassis" v-validate="'required'" class="w-full"
                  autocomplete="off"
              />
              <span class="text-danger">{{ errors.first("general-data.chassis") }}</span>
              <br/>
            </div>

            <div class="vx-col md:w-1/3 w-full">
              <label for="motor" class="w-full select-large">Motor</label>
              <vs-input
                  id="motor" name="motor" v-model="entryModel.features.motor" v-validate="'required'" class="w-full"
                  autocomplete="off"
              />
              <span class="text-danger">{{ errors.first("general-data.motor") }}</span>
              <br/>
            </div>
          </div>

          <vs-divider class="vx-col w-full mt-5" position="left" color="dark">Ubicación</vs-divider>
          <div class="vx-row">
            <div class="vx-col md:w-1/2 w-full">
              <label for="state" class="w-full select-large">Departamento</label>
              <v-select
                  id="state"
                  name="state"
                  label="name"
                  index="id"
                  :options="states"
                  :placeholder="'Seleccione..'"
                  :searchable="true"
                  v-model="entryModel.state"
                  v-validate="'required'"
                  @input="getCities(entryModel.state)"
                  class="w-full"
              />
              <span class="text-danger">{{ errors.first("general-data.state") }}</span>
              <br/>
            </div>

            <div class="vx-col md:w-1/2 w-full">
              <label for="city" class="w-full select-large">Ciudad</label>
              <v-select
                  id="city"
                  name="city"
                  label="name"
                  index="id"
                  :options="cities"
                  :placeholder="'Seleccione..'"
                  :searchable="true"
                  v-model="entryModel.city"
                  v-validate="'required'"
                  class="w-full"
              />
              <span class="text-danger">{{ errors.first("general-data.city") }}</span>
              <br/>
            </div>
          </div>

          <div class="vx-row">
            <div class="vx-col w-full">
              <label for="address" class="w-full select-large">Dirección</label>
              <vs-textarea
                  id="address" name="address" v-model="entryModel.address" v-validate="'required'" rows="3"
                  autocomplete="off"
              />
              <span class="text-danger">{{ errors.first("general-data.address") }}</span>
              <br/>
            </div>
          </div>

          <div class="vx-row">
            <div class="vx-col md:w-1/3 w-full">
              <label for="featured" class="w-full select-large">Destacado</label>
              <vs-select
                  id="featured" name="featured" v-model="entryModel.featured" v-validate="'required'"
                  class="w-full select-large"
              >
                <vs-select-item :key="true" :value="true" :text="'Si'" class="w-full"/>
                <vs-select-item :key="false" :value="false" :text="'No'" class="w-full"/>
              </vs-select>
              <span class="text-danger">{{ errors.first("general-data.featured") }}</span>
              <br/>
            </div>

            <div class="vx-col md:w-1/3 w-full">
              <label for="featured" class="w-full select-large">Aprobado</label>
              <vs-select
                  id="approved" name="approved" v-model="entryModel.approved" v-validate="'required'"
                  class="w-full select-large"
              >
                <vs-select-item :key="true" :value="true" :text="'Si'" class="w-full"/>
                <vs-select-item :key="false" :value="false" :text="'No'" class="w-full"/>
              </vs-select>
              <span class="text-danger">{{ errors.first("general-data.approved") }}</span>
              <br/>
            </div>

            <div class="vx-col md:w-1/3 w-full">
              <label for="priority" class="w-full select-large">Prioridad</label>
              <vs-input
                  type="number"
                  id="priority"
                  name="priority"
                  min="1"
                  max="10"
                  v-model="entryModel.priority"
                  v-validate="'required'"
                  class="w-full"
              />
              <span class="text-danger">{{ errors.first("general-data.priority") }}</span>
              <br/>
            </div>
          </div>

          <vs-divider class="vx-col w-full mt-5" position="left" color="dark">Información de contacto</vs-divider>
          <div class="vx-row">
            <div class="vx-col md:w-1/3 w-full">
              <label for="contact_info_name" class="w-full select-large">Nombre</label>
              <vs-input
                  id="contact_info_name" name="contact_info_name" v-model="entryModel.contact_info.name"
                  v-validate="'required'" class="w-full" autocomplete="off"
              />
              <span class="text-danger">{{ errors.first("general-data.contact_info_name") }}</span>
              <br/>
            </div>

            <div class="vx-col md:w-1/3 w-full">
              <label for="contact_info_phone_number" class="w-full select-large">Teléfono</label>
              <vs-input
                  id="contact_info_phone_number" name="contact_info_phone_number"
                  v-model="entryModel.contact_info.phone_number" v-validate="'required'" class="w-full" autocomplete="off"
              />
              <span class="text-danger">{{ errors.first("general-data.contact_info_phone_number") }}</span>
              <br/>
            </div>

            <div class="vx-col md:w-1/3 w-full">
              <label for="contact_info_email" class="w-full select-large">Correo</label>
              <vs-input
                  id="contact_info_email" name="contact_info_email" v-model="entryModel.contact_info.email"
                  v-validate="'required'" class="w-full" autocomplete="off"
              />
              <span class="text-danger">{{ errors.first("general-data.contact_info_email") }}</span>
              <br/>
            </div>
          </div>

          <vs-divider class="vx-col w-full mt-5" position="left" color="dark">Publicación</vs-divider>
          <div class="vx-row">
            <div class="vx-col md:w-1/2 w-full mt-5">
              <label for="publish_at" class="w-full select-large">Fecha y hora de publicación</label>
              <flat-pickr
                  :config="configdateTimePicker"
                  id="publish_at"
                  name="publish_at"
                  v-model="entryModel.publish_at"
                  class="w-full flatpickr flatpickr-input"
              />
              <br/>
            </div>

            <div class="vx-col md:w-1/2 w-full mt-5">
              <label for="expire_at" class="w-full select-large">Fecha y hora de expiración</label>
              <flat-pickr
                  :config="configdateTimePicker"
                  id="expire_at"
                  v-model="entryModel.expire_at"
                  class="w-full flatpickr flatpickr-input"
              />
              <br/>
            </div>
          </div>
        </form>
      </tab-content>

      <tab-content title="SEO" class="mb-5">
        <div class="vx-row mt-5">
          <div class="vx-col md:w-1/2 w-full">
            <label for="meta_title" class="w-full select-large">Título Meta</label>
            <vs-input
                id="meta_title" name="meta_title" v-model="entryModel.settings.seo.meta_tags.title" v-validate="'required|max:50'"
                class="w-full"
                autocomplete="off"
            />
            <span class="text-danger">{{ errors.first("meta_title") }}</span>
          </div>
        </div>

        <div class="vx-row mt-5">
          <div class="vx-col w-full">
            <label for="meta_description" class="w-full select-large">Descripción Meta</label>
            <vs-textarea id="meta_description" name="meta_description" v-model="entryModel.settings.seo.meta_tags.description"
                         v-validate="'required|max:150'" class="w-full mb-0 resize-none" autocomplete="off"/>
            <span class="text-danger">{{ errors.first("meta_description") }}</span>
          </div>
        </div>

        <div class="vx-row mt-5">
          <div class="vx-col w-full">
            <label for="keywords" class="w-full select-large">Keywords</label>
            <vs-chips color="rgb(145, 32, 159)" v-model="entryModel.settings.seo.meta_tags.keywords.content"
                      name="keywords" id="keywords" v-validate="'min:1'"
                      remove-icon="delete_forever" class="keywords-list">
              <vs-chip
                  :key="keyword"
                  @click="removeKeyword(index)"
                  v-for="(keyword, index) in entryModel.settings.seo.meta_tags.keywords.content" closable close-icon="delete">
                {{ keyword }}
              </vs-chip>
            </vs-chips>
          </div>
        </div>

        <vs-divider class="vx-col w-full mt-8" position="left" color="dark">Imágenes</vs-divider>

        <vs-divider class="vx-col w-full mt-5" position="left" color="light">Open graph</vs-divider>
        <div class="vx-row">
          <div class="vx-col w-full mb-5">
            <uploader
                :classFile="'file-upload-1'"
                @files-removed="removedSEOFiles('og')"
                @files-updated="openGraphUpload"
                :maxNumberOfFiles="1"
                :downloadedFiles="downloadedOGFile"
            />
          </div>
        </div>

        <vs-divider class="vx-col w-full mt-5" position="left" color="light">Twitter</vs-divider>
        <div class="vx-row">
          <div class="vx-col w-full mb-5">
            <uploader
                :classFile="'file-upload-4'"
                :maxNumberOfFiles="1"
                @files-removed="removedSEOFiles('twitter')"
                @files-updated="twitterUpload"
                :downloadedFiles="downloadedTwitterFile"
            />
          </div>
        </div>
      </tab-content>

      <template slot="footer" slot-scope="props">
        <div class="wizard-footer-left">
          <vs-button
              v-if="props.activeTabIndex > 0"
              @click.native="props.prevTab()"
              class="wizard-footer-left finish-button"
          >
            Anterior
          </vs-button>
        </div>

        <div class="wizard-footer-right">
          <vs-button
              v-if="!props.isLastStep"
              class="wizard-footer-right finish-button"
              @click.native="props.nextTab()"
          >Siguiente
          </vs-button>
          <vs-button
              v-else
              class="wizard-footer-right finish-button"
              @click.native="props.nextTab()"
              @click="createOrUpdateEntry"
          >Enviar
          </vs-button>
          <vs-button
              color="danger"
              type="border"
              class="wizard-footer-right finish-button mr-3"
              @click="goToEntriesList"
          >Cancelar
          </vs-button>
        </div>
      </template>
    </form-wizard>
  </vx-card>
</template>

<script>
  import AttributeOptionsClient from "../../utils/attributeOptionsClient";
  import CoreClient from "../../utils/coreClient";
  import EntriesClient from "../../utils/entriesClient";
  import Notifier from "./../../utils/notification";
  import Configurations from "./../../utils/configurations";
  import {FormWizard, TabContent} from "vue-form-wizard";
  import "vue-form-wizard/dist/vue-form-wizard.min.css";
  import flatPickr from "vue-flatpickr-component";
  import "flatpickr/dist/flatpickr.css";
  import Upload from "@/utils/upload";
  import vSelect from "vue-select";
  import { Validator } from 'vee-validate';

  let notifier = new Notifier();
  let configurations = new Configurations();
  const ENTRY_CLIENT = new EntriesClient("salvages");
  const ATTRIBUTE_OPTIONS_CLIENT = new AttributeOptionsClient("salvages");
  const STATES_CLIENT = new CoreClient("states");
  const CITIES_CLIENT = new EntriesClient("cities");
  const UPLOAD = new Upload("resource");

  const requiredFields = [
    "name", "claim_code", "category", "brand", "model", "year", "license_plate", "chassis", "motor", "price", "condition",
    "state", "city", "address", "featured", "approved", "priority", "contact_info_name", "contact_info_phone_number",
    "contact_info_email", "meta_title", "meta_description",
  ];
  let dict = requiredFields.reduce(
    (previousValue, currentValue) => {
      previousValue[currentValue] = { required: "* Este campo es requerido" };
      return previousValue
    },
    {}
  );
  dict["year"].digits = "* Ingrese un valor válido";

  Validator.localize("es", {custom: dict});

  export default {
    data() {
      return {
        configdateTimePicker: configurations.configDatePicker(),
        resource: "salvages",
        categories: [],
        states: [],
        cities: [],
        entryModel: {
          state: null,
          city: null,
          price: null,
          address: null,
          name: null,
          claim_code: null,
          priority: 10,
          approved: true,
          featured: false,
          features: {},
          contact_info: {
            name: null,
            phone_number: null,
            email: null
          },
          condition: null,
          category: null,
          publish_at: null,
          expire_at: null,
          settings: {
            seo: {
              meta_tags: {
                og: {
                  image: null,
                  title: null,
                  description: null
                },
                twitter: {
                  image: null,
                  title: null,
                  description: null
                },
                keywords: {
                  content: [],
                },
                title: null,
                description: null,
              },
            },
          },
          loadedMetaValues: false,
        }
      };
    },

    mounted() {
      if (this.$route.params.id !== undefined) {
        this.$vs.loading();
        this.loadEntryData(this.$route.params.id).then(() => {
          this.$vs.loading.close();
        });
      } else {
        this.$vs.loading();
        this.getCategories(false).then(() => {
          this.getStates().then(() => {
            this.$vs.loading.close();
          });
        });
      }
    },

    computed: {
      validateForm() {
        return !this.errors.any()
          && requiredFields.reduce((accumulator, currentValue) => {
            return accumulator && this.entryModel[currentValue] !== null;
          });
      },

      downloadedTwitterFile(){
        return {
          url: this.entryModel.settings.seo.meta_tags.twitter.image,
          meta: {
            title: this.entryModel.settings.seo.meta_tags.twitter.title,
            description: this.entryModel.settings.seo.meta_tags.twitter.description,
          }
        }
      },

      downloadedOGFile(){
        return {
          url: this.entryModel.settings.seo.meta_tags.og.image,
          meta: {
            title: this.entryModel.settings.seo.meta_tags.og.title,
            description: this.entryModel.settings.seo.meta_tags.og.description,
          }
        }
      },
    },

    methods: {
      async getStates(showLoading = true) {
        if (showLoading) this.$vs.loading();
        await STATES_CLIENT.all()
          .then(response => {
            this.states = response.data;
          }).catch(error => {
            notifier.notification("error");
          });
        this.$vs.loading.close();
      },

      async getCities(state, showLoading = true) {
        if (state !== null && state !== undefined && state !== "") {
          if (showLoading) this.$vs.loading();

          await CITIES_CLIENT.all({queryStrings: {state_id: state.id}})
            .then(response => {
              this.cities = response.data;
              if (showLoading) this.$vs.loading.close();
            })
            .catch(error => {
              if (showLoading) this.$vs.loading.close();
              notifier.notification("error");
            });
        } else {
          this.cities = [];
          this.entryModel.city = null;
        }
      },

      async getCategories(showLoading = true) {
        if (showLoading) this.$vs.loading();

        await ATTRIBUTE_OPTIONS_CLIENT.categories({
          queryStrings: {representation_type: "simple"}
        })
          .then(response => {
            if (showLoading) this.$vs.loading.close();
            this.categories = response.data;
          })
          .catch(error => {
            if (showLoading) this.$vs.loading.close();
            notifier.notification("error");
          });
      },

      async loadEntryData(entryId) {
        await ENTRY_CLIENT.retrieve({pathParameters: {entryId: entryId}})
          .then(response => {
            this.getStates(false)
              .then(() => {
                if (response.data.city !== undefined && response.data.city.id !== null) {
                  this.getCities(response.data.state, false);
                }
              })
              .then(() => {
                this.getCategories(false);
              })
              .then(() => {
                Object.assign(this.entryModel, response.data);

                if(!this.entryModel.settings){
                  this.entryModel.settings = {};
                }

                if(!this.entryModel.settings?.seo){
                  this.entryModel.settings.seo = {
                    meta_tags: {
                      og: {
                        image: null,
                        title: null,
                        description: null
                      },
                      twitter: {
                        image: null,
                        title: null,
                        description: null
                      },
                      keywords: {
                        content: [],
                      },
                      title: null,
                      description: null,
                    },
                  };
                }
              });
          })
          .catch(error => {
            notifier.notification("error");
          });
      },

      async createOrUpdateEntry() {
        const isValid = await this.$validator.validate();
        if(!isValid) {
          return;
        }

        this.cleanModel();

        if (this.entryModel.id !== null && this.entryModel.id !== undefined && this.entryModel.id !== "") {
          this.$vs.loading();
          await ENTRY_CLIENT.update({pathParameters: {entryId: this.entryModel.id}, data: this.entryModel})
            .then(response => {
              this.$vs.loading.close();
              notifier.notification("updated");
              this.goToEntriesList();
            })
            .catch(error => {
              this.errors = error.response.data.errors;
              this.$vs.loading.close();
              notifier.alertMessage("error");
            });

        } else {
          this.$vs.loading();
          await ENTRY_CLIENT.create({data: this.entryModel})
            .then(response => {
              this.$vs.loading.close();
              notifier.notification("created");
              this.goToEntriesList();
            })
            .catch(error => {
              this.errors = error.response.data.errors;
              this.$vs.loading.close();
              notifier.alertMessage("error");
            });
        }
      },

      cleanModel() {
        Object.keys(this.entryModel).forEach(key => {
          if (this.entryModel[key] === null || this.entryModel[key] === "") {
            delete this.entryModel[key];
          }
        })
      },

      async openGraphUpload(files) {
        if (files.length > 0) {
          await UPLOAD.uploadFiles({
            queryStrings: {resource_type: this.resource, content_type: files[0].type},
            files: files
          })
              .then(response => {
                this.entryModel.settings.seo.meta_tags.og.image = response;
                this.entryModel.settings.seo.meta_tags.og.title = files[0].meta.name ? files[0].meta.name : null;
                this.entryModel.settings.seo.meta_tags.og.description = files[0].meta.caption ? files[0].meta.caption : null;
              })
              .catch(error => {
                notifier.notification("error");
              });
        }
      },

      async twitterUpload(files) {
        if (files.length > 0) {
          await UPLOAD.uploadFiles({
            queryStrings: {resource_type: this.resource, content_type: files[0].type},
            files: files
          })
              .then(response => {
                this.entryModel.settings.seo.meta_tags.twitter.image = response;
                this.entryModel.settings.seo.meta_tags.twitter.title = files[0].meta.name ? files[0].meta.name : null;
                this.entryModel.settings.seo.meta_tags.twitter.description = files[0].meta.caption ? files[0].meta.caption : null;
              })
              .catch(error => {
                notifier.notification("error");
              });
        }
      },

      async removedSEOFiles(files) {
        let metaTags = this.entryModel.settings.seo.meta_tags;
        let body = metaTags[files].image;

        body = JSON.stringify({url: body});

        await UPLOAD.removeFiles({data: body}).then(response => {
          metaTags[files] = {
            image: null,
            title: null,
            description: null,
          };
        }).catch(error => {
          notifier.notification("error");
        });
      },

      goToEntriesList() {
        this.$router.push({name: "salvages"});
      },

      validateGeneralData() {
        return new Promise((resolve, reject) => {
          this.$validator.validateAll("general-data")
              .then(result => {
                if (result) {
                  resolve(true);
                } else {
                  reject("Please fix invalid fields");
                }
              })
        });
      },

      removeKeyword(index) {
        this.entryModel.settings.seo.meta_tags.keywords.content.splice(index, 1)
      },
    },
    components: {
      FormWizard,
      TabContent,
      flatPickr,
      "v-select": vSelect
    },
  };
</script>

<style lang="scss" scoped>
  .keywords-list {
    border: 1px solid rgba(0, 0, 0, 0.2);
    border-radius: 5px;
  }
</style>
